import type {AppProps} from 'next/app';
import '../../public/css/styles.css';

import 'primeicons/primeicons.css';
import '../../styles/globals.css';

import 'primereact/resources/themes/lara-light-amber/theme.css';

import {PrimeReactProvider} from 'primereact/api'; // Import Prime React

export default function App({Component, pageProps}: AppProps) {
    return (
        <PrimeReactProvider>
            <Component {...pageProps} />
        </PrimeReactProvider>

    );
}
